import * as z from "zod";

export const hasCarrierServices = {
  name: "hasCarrierServices" as const,
  input: z.null(),
  output: z.boolean(),
};
